import {
  APP_ID_HEADER,
  WORKSPACE_ID_HEADER,
} from '@flowx/designer/modules/workspaces/shared/commons.types'

import { ACCESS_TOKEN_STORAGE_KEY } from './auth.constants'

/**
 * The headers a stream has to stamp for itself.
 *
 * `HttpClient` is not on the path for any of them — `EventSource`/`EventSourcePolyfill` and
 * `fetch` both bypass the interceptor chain — so the bearer, the workspace and the app id, which
 * `OAuthModule`, `WorkspacesInterceptor` and `AiAppIdInterceptor` would otherwise attach, have to
 * be written by hand. Written once here: this set is security-relevant, and two copies of it drift
 * in one direction only.
 */
export function aiStreamHeaders(
  workspaceId: string | null,
  appId: string | null
): Record<string, string> {
  const token = readAccessToken()

  return {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(workspaceId && { [WORKSPACE_ID_HEADER]: workspaceId }),
    ...(appId && { [APP_ID_HEADER]: appId }),
  }
}

/** A plain read, so a missing token degrades to an unauthenticated call — a visible 401 at the
 * gateway — rather than throwing before the request is made. */
function readAccessToken(): string {
  try {
    return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}
